import { KikHttpTwoConfig, KikHttpTwoService } from "@kikocosmeticsorg/uc-api-nest-common-fe";

import { CorrelationId } from "~/services/correlation-id";
import { ApiConstants } from "~/shared/api/api-constants.class";
import { ErrorResponse } from "~/shared/api/error-response.class";

export type HttpConfig<T = any> = KikHttpTwoConfig<T>;

export class HttpService extends KikHttpTwoService {
  static get errorClass() {
    return this._errorClass;
  }

  // @override
  protected static _errorClass = ErrorResponse;
  protected static _organizationUnitId: string = "";
  // Sent on server-to-server requests so Radware (bot manager in front of the public MAPI) does
  protected static _serverUserAgent: string = "kiko-unified-commerce-ssr";

  static updateOrganizationUnitId(organizationUnitId: string) {
    this._organizationUnitId = organizationUnitId;
  }

  protected static async _preprocessRequest<T>(config: KikHttpTwoConfig<T>): Promise<KikHttpTwoConfig<T>> {
    if (ApiConstants.isInternalUrl(config.url)) {
      config.useCredentials = !0; // Send cookie to domain
      config.headers = {
        [ApiConstants.headers.X_CORRELATION_ID]: CorrelationId.get(),
        [ApiConstants.headers.X_LOCALE]:
          typeof location !== "undefined"
            ? `${location?.href}`.match(/\/([a-zA-Z]{2}-[a-zA-Z]{2})\//)?.[1] || "default" // the current locale
            : "server",
        [ApiConstants.headers.X_ORGANIZATION_UNIT_ID]: this._organizationUnitId,
        ...(typeof window === "undefined" ? { "User-Agent": this._serverUserAgent } : {}),
        ...config.headers,
      };
    }

    return config;
  }
}
